module.exports = __webpack_public_path__ + "img/rmg.829edcc2.svg";